/**
 * Created by Andrey Popov on 24.06.20
 */

const MarkView = cc.Node.extend({
    ctor: function (mark) {
        this._super();
        this.mark = mark;
        this.styles = cleverapps.styles.MarkView[this.mark.type];

        if (cleverapps.environment.isSceneWithPreview()) {
            this.styles = cleverapps.overrideStyles(this.styles, this.styles.editor || {}, true);
        }
        const content = this.content = new cleverapps.Spine(bundles.card.jsons[`${this.mark.type}_json`]);
        content.setAnchorPoint(0.5, 0.5);
        this.setAnchorPoint(0.5, 0.5);

        content.setAnimation(0, this.mark.type === "magnet" ? "magnet_idle_0" : "animation", true);
        content.setTimeScale(0.7 + Math.random() * 0.6);
        content.setScale(0);
        this.addChild(this.content);
        this.mark.on("show", this.show.bind(this));
        this.mark.on("collect", this.collect.bind(this));
        this.mark.on("collectMagnet", this.collectMagnet.bind(this));
        this.mark.on("executeMagnet", this.executeMagnet.bind(this));

        if (!cleverapps.environment.isSceneWithPreview()) {
            this.mark.on("hide", this.hide.bind(this));
        }
    },

    show: function (silent, callback) {
        const content = this.content;
        this.setVisible(true);
        content.setAlignment(this.styles);

        if (silent) {
            content.setScale(1);
            return;
        }

        const spark = new cleverapps.Spine(bundles.card.jsons.effects_json);
        spark.setAnimation(0, "appearance_corner", false);
        spark.setAlignment(this.x, this.y);
        this.addChild(spark);

        content.runAction(new cc.Sequence(
            new cc.DelayTime(0.33),
            new cc.ScaleTo(0.33, 1),
            new cc.CallFunc(() => {
                spark.removeFromParent();
                if (callback) {
                    callback();
                }
            })
        ));
    },

    hide: function () {
        this.setVisible(false);
    },

    collect: function (target) {
        if (!target) {
            this.removeFromParent();
            return;
        }

        this.content.setTimeScale(1);

        if (this.mark.type === "mission") {
            MissionCollectDelta.showOver(Mission.TYPE_LIGHTNING_RUSH, 1, this.content);
        }

        const position = this.convertToWorldSpace(this.content.getPosition());
        this.setAlignment(this.getParent().convertToNodeSpace(position));
        this.content.setAlignment(this.width / 2, this.height / 2);
        this.setLocalZOrder(100);
        this.runAction(new cc.Sequence(
            new cc.Spawn(
                StandartAnimations.animateCollect(this, target, {
                    duration: Mark.COLLECT_DURATION / 1000,
                    effect: `solitaire.mark.collect.${this.mark.type}`,
                    collectEffect: true
                }),
                new cc.RotateTo(Mark.COLLECT_DURATION / 1000, 0)
            ),
            new cc.RemoveSelf()
        ));
    },

    collectMagnet: function () {
        const content = this.content;
        content.setTimeScale(1);
        content.setAnimation(0, "magnet_jump", false);

        const movingNode = cleverapps.Scenes.GetMovingNode();

        let targetPosition = this.convertToWorldSpace(cc.p(this.x + this.styles.offset.x, this.y + this.styles.offset.y));
        targetPosition = movingNode.convertToNodeSpace(targetPosition);

        this.runAction(new cc.Sequence(
            new cc.ReplaceParent(movingNode),
            cleverapps.effects.fireAction("solitaire.magnet.collect"),
            new cc.Spawn(
                new cc.MoveTo(Mark.COLLECT_DURATION / 1000 - 0.1, targetPosition),
                new cc.RotateTo(Mark.COLLECT_DURATION / 1000 - 0.1, 0)
            ),
            new cc.DelayTime(0.1),
            new cc.CallFunc(() => {
                content.setAnimation(0, "magnet_idle_1", true);
            })
        ));
    },

    executeMagnet: function (cardsToDestroy) {
        const content = this.content;
        this.stopAllActions();
        content.setAnimation(0, "magnet_open", false);
        content.setCompleteListenerRemove();

        cleverapps.effects.fire("solitaire.magnet.explode");
        cardsToDestroy.forEach((target) => {
            const targetView = target.onGetView();
            if (!targetView || !targetView.getParent()) {
                return;
            }
            const targetPosition = this.convertToNodeSpace(targetView.getParent().convertToWorldSpace(targetView.getPosition()));

            const lightning = new cleverapps.Spine(bundles.card.jsons.lightning_json);
            this.addChild(lightning);
            lightning.setAlignment(this.width / 2, this.height / 2);
            lightning.setAnimation(0, "animation", false);

            const dx = targetPosition.x - lightning.x;
            const dy = targetPosition.y - lightning.y;
            lightning.setRotation(Math.atan2(-dy, dx) * 180 / Math.PI);
            lightning.setScaleX(Math.sqrt(dx * dx + dy * dy) / this.styles.lightningLength);

            lightning.runAction(new cc.Sequence(
                new cc.DelayTime(0.3),
                new cc.RemoveSelf()
            ));
        });
    }
});

cleverapps.styles.MarkView = {
    "mission": {
        x: 15,
        y: 15
    },

    "key": {
        x: 105,
        y: 30,

        editor: {
            x: { align: "center" },
            y: { align: "center", dy: 60 }
        }
    },

    "coin": {
        x: 15,
        y: 15
    },

    "magnet": {
        x: 95,
        y: 20,

        offset: {
            x: 0,
            y: 150
        },

        lightningLength: 530,

        editor: {
            x: { align: "center" },
            y: { align: "center", dy: -20 }
        }
    },

    "bone": {
        x: 90,
        y: 80
    }
};
